import Loading from '@src/main/ui/components/layout/common/Loading/Loading';
import ProvidersLayout from '@src/main/ui/components/layout/common/ProvidersLayout';
import UserMenu from '@src/main/ui/components/layout/common/UserMenu/UserMenu';
import { useDashboardContext } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import { PropsWithChildren, type FC } from 'react';
import { Outlet } from 'react-router-dom';

interface Props {
  OutletParent: FC<PropsWithChildren>;
}

const MainLayout: FC<Props> = ({ OutletParent }) => {
  const { isLoading } = useDashboardContext();
  if (isLoading) return <Loading />;

  return (
    <ProvidersLayout>
      <OutletParent>
        <UserMenu />
        <Outlet />
      </OutletParent>
    </ProvidersLayout>
  );
};

export default MainLayout;
